import React from "react";
import { motion } from "framer-motion";
import { Check, Sparkles } from "lucide-react";

const PLANS = [
  {
    title: "انتشار رایگان موزیک",
    price: "$0",
    billing: "رایگان",
    desc: "شروع رایگان برای هنرمندان تازه‌کار که می‌خواهند بدون هزینه، اولین اثر خود را در پلتفرم‌های جهانی منتشر کنند.",
    features: [
      "انتشار جهانی موزیک",
      "ثبت اطلاعات اثر",
      "پشتیبانی فارسی",
      "تعداد انتشار موزیک: نامحدود",
      "زمان انتظار برای انتشار: ۳ هفته",
    ],
    cta: "ثبت درخواست رایگان",
    type: "music",
    badge: "تازه کارها",
    badgeStyle: "from-cyan-400 to-blue-500",
  },
  {
    title: "انتشار موزیک",
    price: "۲۵$",
    billing: "سالانه",
    desc: "مناسب برای انتشار آهنگ، تک‌آهنگ یا آثار صوتی در پلتفرم‌های بین‌المللی با اولویت بالا.",
    features: [
      "انتشار جهانی موزیک",
      "ثبت اطلاعات اثر",
      "پشتیبانی فارسی",
      "اولویت در صف انتشار",
      "تعداد انتشار موزیک: نامحدود",
      "زمان انتظار برای انتشار: ۷۲ ساعت",
      "تمدید سالانه",
    ],
    cta: "ثبت درخواست انتشار موزیک",
    type: "music",
    badge: "حرفه ای ها",
    badgeStyle: "from-purple-500 to-pink-500",
  },
  {
    title: "انتشار موزیک‌ویدیو",
    price: "۱۲۰$",
    billing: "سالانه",
    desc: "مناسب برای انتشار موزیک‌ویدیو و مدیریت درآمد ویدیو در پلتفرم‌های بین‌المللی.",
    features: [
      "انتشار موزیک‌ویدیو",
      "مدیریت اطلاعات ویدیو",
      "پشتیبانی فارسی",
      "مناسب برای هنرمندان و لیبل‌ها",
      "تعداد انتشار موزیک: نامحدود",
      "تمدید سالانه",
    ],
    cta: "ثبت درخواست انتشار ویدیو",
    type: "video",
  },
];

export default function Pricing() {
  const scrollToForm = (type) => {
    const el = document.querySelector("#register");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setTimeout(() => {
      const sel = document.querySelector('[data-testid="form-request-type"]');
      if (sel) {
        sel.value = type;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }, 600);
  };

  return (
    <section id="pricing" className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight">
            تعرفه‌های <span className="gradient-text-neon">شفاف</span> برای انتشار جهانی
          </h2>
          <p className="mt-4 text-slate-300 leading-relaxed">
            هزینه‌ها ساده، مشخص و بدون پیچیدگی طراحی شده‌اند تا هنرمند بداند برای انتشار و دریافت درآمد چه مسیری پیش رو دارد.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6 items-stretch">
          {PLANS.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative rounded-[2rem] p-8 transition-all glass glass-hover"
              data-testid={`pricing-card-${i}`}
            >
              {p.badge && (
                <div
                  className={`absolute -top-3 right-6 px-3 py-1 rounded-full text-xs font-bold bg-gradient-to-l ${p.badgeStyle} text-black inline-flex items-center gap-1 shadow-lg`}
                  data-testid={`pricing-badge-${i}`}
                >
                  <Sparkles className="w-3 h-3" />
                  {p.badge}
                </div>
              )}

              <h3 className="text-xl font-bold">{p.title}</h3>
              <div className="mt-6 flex items-baseline gap-2">
                <span className="text-5xl font-black gradient-text-neon">{p.price}</span>
                <span className="text-sm text-slate-400">/ {p.billing}</span>
              </div>
              <p className="mt-3 text-sm text-slate-300 leading-relaxed">{p.desc}</p>

              <ul className="mt-6 space-y-2.5">
                {p.features.map((f, j) => (
                  <li key={j} className="flex items-start gap-2 text-sm text-slate-200">
                    <Check className="w-4 h-4 text-cyan-300 mt-0.5 shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => scrollToForm(p.type)}
                className="mt-8 w-full justify-center btn-secondary"
                data-testid={`pricing-cta-${i}`}
              >
                {p.cta}
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
